<template>
  <el-carousel style="width:100%;" indicator-position="outside">
    <el-carousel-item v-for="item in [1]" :key="item">
    <!-- <el-carousel-item v-for="item in [1,2,3]" :key="item"> -->
      <div
        class="banner1"
        v-bind:style="{'background-image':'url(/static/slide/0' + item + '.jpg)'}"
      ></div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "Banner"
};
</script>

<style lang="scss" scoped>
.banner1 {
    width: 80%;
    height: 297px;
    background-position: center center;
    background-size: 80% 100%;
    background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/common/banner.vue